import { Entity } from '../../entity';
import { PriorityTiny } from '../../job/priority.tiny';

/**
 * Value shapes shared by a template Service Line and a live one.
 *
 * They live on the template side because that is the reusable half: `ServiceLine` inherits from
 * `ServiceLineTemplate`, so anything both levels carry is DECLARED once here and imported by the
 * live module, never the other way round. Kept in their own leaf file so importing them does not
 * pull in either line interface — that is what keeps the template/live relationship acyclic.
 */

export interface ServiceLineDefaultWindow {
    start: string;
    end: string;
    overnight?: boolean;
}

/**
 * When a line's Visits are attended. Derived from the window, never stored: a stored mode beside the
 * window could disagree with it, and every reader (forecast, materialiser, merge, stamper, age) already
 * reads a missing window as the whole local day.
 */
export enum ServiceLineAppointment {
    Timed = 'Timed',
    AnyTime = 'AnyTime',
}

/** The window a new Timed line starts with, so choosing Timed offers a working day rather than blanks. */
export const DEFAULT_SERVICE_LINE_WINDOW: Readonly<ServiceLineDefaultWindow> = { start: '09:00', end: '17:00', overnight: false };

/** A window with both ends is Timed; anything less is Any time on the day. */
export function serviceLineAppointment(window: ServiceLineDefaultWindow | null | undefined): ServiceLineAppointment {

    return window?.start && window.end ? ServiceLineAppointment.Timed : ServiceLineAppointment.AnyTime;
}

/** Defaults copied onto Jobs generated from a Service Line occurrence. */
export interface ServiceLineJobDefaults {
    _id: string;
    name?: string;
    description?: string;
    /** Default duration for Jobs generated from this line, in minutes. Non-negative. */
    duration?: number;
    workCategory?: Entity | null;
    priority?: PriorityTiny;
    type?: Entity;
    labels?: Entity[];
    owner?: Entity;
    fieldSupervisor?: Entity;
    priceBook?: Entity;
    company?: Entity;
    quoteTemplate?: Entity;
    customFields?: any;
}
